<template>
    
    <tr class="bundled_product_summary product-recap menu_menu border-bottom">
        <td class="bundled_item_col bundled_item_qty_col text-center">
            <span class="fs-xs d-flex justify-content-center align-items-center quantity rounded-pill text-bg-dark">
                {{prod.quantity}}
            </span>
        </td>
        <td class="bundled_item_col bundled_item_images_col">
            <div class="bundled_product_images images" style="opacity: 1;">
                <figure v-if="prod.image" class="bundled_product_image woocommerce-product-gallery__image">
                    <img :src="(prod.image ? prod.image : '')" class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail wp-post-image" alt="" decoding="async" :title="prod.post_title" >
                </figure>
            </div>
        </td>
        <td class="bundled_item_col bundled_item_details_col">
            <span class="fs-xs item_title">{{ prod.name }}</span>
        </td>
        
    </tr>
</template>

<script>
export default {
    name: "ProductRecap",
    props: {
        prod: Object
    }
}
</script>

<style lang="scss" scoped>
.product-recap{
    img{
        width: 80px;
        height: auto;
    }
    td{
        padding: 1.5em;
        padding-left: 0;
        vertical-align: middle;
    }
    .quantity{
        width: 30px;
        height: 30px;
    }
    .bundled_item_col.bundled_item_images_col{
        width: 100px;
    }
    .bundled_item_col.bundled_item_qty_col{
        width: 100px;
    }
}
</style>